export default __webpack_public_path__ + "static/media/nobills.74f75823.png";